import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

/* eslint-disable react/jsx-no-bind */
import React from 'react';
import types from 'prop-types';
import { styled } from '@rexlabs/styling';
import styles from '../styles/day-picker-navigation';
import { DayPickerNavigationPhrases } from '../defaultPhrases';
import getPhraseTypes from '../utils/getPhrasePropTypes';
import ScrollableOrientationShape from '../shapes/ScrollableOrientationShape';
import { HORIZONTAL_ORIENTATION, VERTICAL_SCROLLABLE } from '../constants';
var propTypes = process.env.NODE_ENV !== "production" ? {
  navPrev: types.node,
  navNext: types.node,
  orientation: ScrollableOrientationShape,
  onPrevMonthClick: types.func,
  onNextMonthClick: types.func,
  labels: types.shape(getPhraseTypes(DayPickerNavigationPhrases)),
  isRTL: types.bool
} : {};
var defaultProps = {
  navPrev: null,
  navNext: null,
  orientation: HORIZONTAL_ORIENTATION,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  labels: DayPickerNavigationPhrases,
  isRTL: false
};

var DayPickerNavigation = function DayPickerNavigation(_ref) {
  var navPrev = _ref.navPrev,
      navNext = _ref.navNext,
      onPrevMonthClick = _ref.onPrevMonthClick,
      onNextMonthClick = _ref.onNextMonthClick,
      orientation = _ref.orientation,
      labels = _ref.labels,
      isRTL = _ref.isRTL,
      styles = _ref.styles;
  return React.createElement("div", styles(_defineProperty({
    container: true,
    rtl: isRTL
  }, orientation, true)), orientation !== VERTICAL_SCROLLABLE && React.createElement("button", _extends({}, styles(_defineProperty({
    prev: true
  }, "prev_".concat(orientation), true)), {
    type: "button",
    "aria-label": labels.jumpToPrevMonth,
    onClick: onPrevMonthClick,
    onMouseUp: function onMouseUp(e) {
      e.currentTarget.blur();
    }
  }), navPrev), React.createElement("button", _extends({}, styles(_defineProperty({
    next: true
  }, "next_".concat(orientation), true)), {
    type: "button",
    "aria-label": labels.jumpToNextMonth,
    onClick: onNextMonthClick,
    onMouseUp: function onMouseUp(e) {
      e.currentTarget.blur();
    }
  }), navNext));
};

DayPickerNavigation.displayName = 'DayPickerNavigation';
DayPickerNavigation.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
DayPickerNavigation.defaultProps = defaultProps;
export default styled(styles)(DayPickerNavigation);